import LanguagePicker from 'js/components/LanguagePicker'
import NavigationChat from 'js/components/NavigationChat/NavigationChat'
import NavigationNotifications from 'js/components/NavigationNotifications/NavigationNotifications'
import NavigationPortal from 'js/components/NavigationPortal/NavigationPortal'
import NavigationSearch from 'js/components/NavigationSearch/NavigationSearch'
import NavigationUserMenu from 'js/components/NavigationUserMenu/NavigationUserMenu'
import { Show } from 'js/components/Show'

import styles from './NavigationTools.module.css'

const NavigationTools = ({ site, viewer }) => (
    <div className={styles.tools}>
        <Show from="mobileLandscape">
            <NavigationSearch />
        </Show>
        {viewer?.loggedIn ? (
            <>
                {site.chatEnabled && <NavigationChat user={viewer.user} />}
                <NavigationNotifications viewer={viewer} />
                <NavigationUserMenu viewer={viewer} />
            </>
        ) : (
            <>
                <LanguagePicker />
                <NavigationPortal />
            </>
        )}
    </div>
)

export default NavigationTools
